import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import ActionBtns from './ActionBtns';
import FormModal from './FormModal';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
// ─────────────────────────────────────────────────────────────────────────────
// 1. CATEGORIES PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const CategoriesPage = ({ companyId }) => {
  const crud = useCRUD(categoryController, companyId);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [saving, setSaving]     = useState(false);
  const [form, setForm]         = useState({ name:'', code:'', description:'', sortOrder:0, status:'Active' });
  const set = (k,v) => setForm(p=>({...p,[k]:v}));
  const [errors, setErrors]     = useState([]);
const fmt   = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '—';

  const openAdd  = () => { setEditItem(null); setForm({ name:'',code:'',description:'',sortOrder:0,status:'Active' }); setErrors([]); setShowForm(true); };
  const openEdit = (r) => { setEditItem(r); setForm({...r}); setErrors([]); setShowForm(true); };

  const handleSave = async () => {
    setSaving(true); setErrors([]);
    const res = editItem
      ? await categoryController.update(editItem.id, { ...form, companyId })
      : await categoryController.create({ ...form, companyId });
    setSaving(false);
    if (res.success) { crud.show(res.message); setShowForm(false); crud.fetchAll(); }
    else setErrors(res.errors?.length ? res.errors : [res.message]);
  };

  const columns = [
    { label:'Code',  key:'code',  render: v => <span style={{ fontFamily:'monospace', fontSize:12, color:C.primary }}>{v||'—'}</span> },
    { label:'Category Name', key:'name', render: v => <div style={{ fontWeight:700 }}>{v}</div> },
    { label:'Description', key:'description', render: v => <div style={{ maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12, color:C.textSoft }}>{v||'—'}</div> },
    { label:'Sort Order', key:'sortOrder' },
    { label:'Status', key:'status', render: v => <StatusBadge status={v}/> },
    { label:'Created', key:'createdAt', render: v => fmt(v) },
    { label:'', key:'actions', render:(_, r) => <ActionBtns onEdit={()=>openEdit(r)} onDelete={()=>crud.handleDelete(r.id, `"${r.name}"`)} /> },
  ];

  return (
    <div style={S.page}>
      {crud.ToastEl}{crud.Dialog}
      <PageHeader title="Categories" subtitle="Manage product categories" Icon={Tag} color={C.primary}
        action={<button style={S.btnPri} onClick={openAdd}><Plus size={15}/> Add Category</button>} />
      <div style={S.card}>
        <div style={{ padding:'14px 14px 0' }}>
          <FilterBar search={crud.search} onSearch={crud.setSearch}
            filters={[{ key:'status', value:crud.filters.status||'All', onChange:v=>crud.setFilters(p=>({...p,status:v==='All'?'':v})),
              options:[{value:'All',label:'All Status'},{value:'Active',label:'Active'},{value:'Inactive',label:'Inactive'}] }]} />
        </div>
        <DataTable columns={columns} data={crud.data} loading={crud.loading} emptyTitle="No categories found"
          page={crud.page} totalPages={crud.totalPages} onPageChange={crud.setPage} total={crud.total} />
      </div>

      {showForm && (
        <FormModal title={editItem ? 'Edit Category' : 'Add Category'} onClose={()=>setShowForm(false)} onSave={handleSave} saving={saving}>
          <ErrList errors={errors} />
          <FormGrid>
            <FormField label="Category Name *"><input style={S.input} value={form.name} onChange={e=>set('name',e.target.value)} placeholder="e.g. Electronics" /></FormField>
            <FormField label="Code"><input style={S.input} value={form.code} onChange={e=>set('code',e.target.value)} placeholder="e.g. ELEC" /></FormField>
            <FormField label="Sort Order"><input type="number" style={S.input} value={form.sortOrder} onChange={e=>set('sortOrder',e.target.value)} /></FormField>
            <FormField label="Status"><select style={S.select} value={form.status} onChange={e=>set('status',e.target.value)}><option>Active</option><option>Inactive</option></select></FormField>
            <FormField label="Description" col={2}><textarea style={S.textarea} value={form.description} onChange={e=>set('description',e.target.value)} /></FormField>
          </FormGrid>
        </FormModal>
      )}
    </div>
  );
};
export default CategoriesPage;